import { NavigateFunction } from 'react-router-dom'

/**
 * Utility functions for navigation and redirects
 */

export const navigation = {
  /**
   * Redirect to dashboard after successful login
   */
  redirectToDashboard: (navigate: NavigateFunction, delay: number = 500) => {
    setTimeout(() => {
      navigate('/dashboard', { replace: true })
    }, delay)
  },

  /**
   * Redirect to login page
   */
  redirectToLogin: (navigate: NavigateFunction, delay: number = 0) => {
    setTimeout(() => {
      navigate('/login', { replace: true })
    }, delay)
  },

  /**
   * Redirect to a specific page
   */
  redirectTo: (navigate: NavigateFunction, path: string, delay: number = 0, replace: boolean = false) => {
    setTimeout(() => {
      navigate(path, { replace })
    }, delay)
  },

  /**
   * Get the intended destination from URL params or localStorage
   */
  getIntendedDestination: (): string => {
    const urlParams = new URLSearchParams(window.location.search)
    const intended = urlParams.get('redirect') || localStorage.getItem('intendedDestination')
    // '/' renders HomeRedirect, which picks /dashboard or /driver by permission —
    // a hardcoded '/dashboard' here would strand driver-only logins on a page
    // whose every query errors for them.
    return intended || '/'
  },

  /**
   * Store intended destination for post-login redirect
   */
  setIntendedDestination: (path: string) => {
    localStorage.setItem('intendedDestination', path)
  },

  /**
   * Clear intended destination
   */
  clearIntendedDestination: () => {
    localStorage.removeItem('intendedDestination')
  }
}



